module.exports = __webpack_public_path__ + "img/pigai-iocn-02.ab04cfbd.png";